document.addEventListener('DOMContentLoaded', () => {
  const telefonoInput = document.querySelector('input[name="telefono"]') as HTMLInputElement | null;
  const nombresInput = document.querySelector('input[name="nombres"]') as HTMLInputElement | null;
  const apellidosInput = document.querySelector('input[name="apellidos"]') as HTMLInputElement | null;
  const dniInput = document.querySelector('input[name="dni"]') as HTMLInputElement | null;

  if (telefonoInput) {
    telefonoInput.addEventListener('input', () => {
      // Permitir solo números
      telefonoInput.value = telefonoInput.value.replace(/[^0-9]/g, '');
      // Limitar a 9 dígitos
      if (telefonoInput.value.length > 9) {
        telefonoInput.value = telefonoInput.value.slice(0, 9);
      }
    });
  }

  if (nombresInput) {
    nombresInput.addEventListener('input', () => {
      // Permitir solo letras y espacios
      nombresInput.value = nombresInput.value.replace(/[^a-zA-Z\s]/g, '');
    });
  }

  if (apellidosInput) {
    apellidosInput.addEventListener('input', () => {
      // Permitir solo letras y espacios
      apellidosInput.value = apellidosInput.value.replace(/[^a-zA-Z\s]/g, '');
    });
  }

  if (dniInput) {
    dniInput.addEventListener('input', () => {
      // Permitir solo números
      dniInput.value = dniInput.value.replace(/[^0-9]/g, '');
      // Limitar a 8 dígitos
      if (dniInput.value.length > 8) {
        dniInput.value = dniInput.value.slice(0, 8);
      }
    });
  }
});